module.exports = require("@bechtel/client-assets/dist/images/unauthorized.svg");